import { providerLabel } from '@/services/api/integrations/accountingProviders'
import { useXeroMapping } from '@/services/api/integrations/useXeroMapping'

/**
 * Name of the accounting software this Space imports from ("Xero", "Zoho
 * Books"), for wording on the shared mapping and Bank Feed screens. Reads the
 * mapping overview those screens already load.
 */
export function useAccountingProviderLabel(): string {
  const { data } = useXeroMapping()

  return providerLabel(data?.connection?.provider)
}
